import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import { NuInput, NuTextArea } from "../../../Components/Utils/Input";
import useAddFormData from "../../../Components/Hooks/useAddFormData";
import {
  BackButton,
  CancelButton,
  SaveButton,
  SubmitButton,
} from "../../../Components/Utils/Buttons";

function CreateForms() {
  const navigate = useNavigate();
  const { addFormData } = useAddFormData();
  const [formData, setFormData] = useState([]);
  const [createNew, setCreateNew] = useState({
    Description: "",
    Subject: "",
    TicketDate: "",
    ResponseDate: "",
    Status: "",
    title: "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: async (value, { resetForm }) => {
      addFormData("/employees/ ", value, resetForm);
    },
  });

  function handleTitleAdd() {
    let data = {
      title: formik.values.title,
      formData: [],
    };
    setFormData((prev) => [...prev, data]);
    formik.setFieldValue("title", "");
  }

  return (
    <div className=" w-full h-full py-2 px-4 ">
      <div className="flex justify-end w-full">
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                Forms :
              </p>
            </div>
            <div className=" w-full flex justify-between items-center">
              <NuInput
                label="Title"
                type="text"
                formik={formik}
                placeholder="Enter Title"
                name="title"
                width="w-full md:w-1/2 lg:w-[96%]"
              />
              <div className=" mt-8 ">
                <SaveButton label="Add " handleClick={handleTitleAdd} />
              </div>
            </div>

            {formData && formData.length > 0 ? (
              formData.map((item, i) => {
                return (
                  <div
                    className="w-full my-0.5 flex justify-between items-center text-[#111537] bg-[#e8ecf9]"
                    key={i}
                  >
                    <p className=" py-3 px-3 text-sm font-medium  ">
                      {item.title}
                    </p>
                    <p className=" pr-3">+</p>
                  </div>
                );
              })
            ) : (
              <></>
            )}

            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateForms;
